<template>
    <div class="content">
      <h1>Getting Into Programming</h1>
      <p>Placeholder.</p>
    </div>

</template>


